/* eslint-disable import/prefer-default-export */
import router from 'next/router';

/**
 * get page source for analytics, please check this function before use it;
 */
function getAnalyticsPageSource() {
  const path = router.pathname;
  switch (path) {
    case '/stream':
      return 'Stream';
    case '/[username]':
      return 'Profile';
    case '/symbol/[symbol]':
      return 'Company';
    default:
      return null;
  }
}

export {
  getAnalyticsPageSource,
};
